import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
  Type,
} from '@angular/core';
import { Router } from '@angular/router';
import { SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT } from '@softapps/allgemein/utils';
import {
  BlockingLoadingSpinnerComponent,
  SOFTLINE_FEATURE_MASTER_DATA,
} from '@softline/application';
import {
  AuthenticationContextStore,
  SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
} from '@softline/auth';
import { RemoteObjectStore, Store } from '@softline/core';
import { LegacyModalOption } from '@softline/ui-core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { PatchContextService } from '../../services/patch-context.service';
import { Firma } from '../data/firma';

@Component({
  selector: 'soft-firma-context-widget',
  imports: [CommonModule, BlockingLoadingSpinnerComponent],
  templateUrl: './firma-context-widget.component.html',
  styleUrls: ['./firma-context-widget.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmaContextWidgetComponent {
  readonly pending$ = new BehaviorSubject(false);

  firmen$ = this.store
    .observe(SOFTLINE_FEATURE_MASTER_DATA, RemoteObjectStore.getters.data)
    .pipe(map((o) => (o as { firmaModule: Firma[] })?.firmaModule ?? []));

  activeFirmaId$ = this.store
    .observe(
      SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
      AuthenticationContextStore.getters.data
    )
    .pipe(map((o) => (o as any)?.firmaid));

  selectedFirma$ = combineLatest([this.firmen$, this.activeFirmaId$]).pipe(
    map(([firmen, currentFirmaId]) => firmen.find(({ id }) => id === currentFirmaId))
  );

  constructor(
    private store: Store,
    private router: Router,
    private patchContextService: PatchContextService,
    @Optional()
    @Inject(SOFTLINE_CONFIG_EDIT_CONTEXT_COMPONENT)
    public components?: Type<Component>[]
  ) {}

  async onChangeCompany(firmen: Firma[]): Promise<void> {
    const options = firmen.map<LegacyModalOption<string>>((o) => ({
      value: o?.id + '',
      label: o?.firma ?? o?.kurzbezeichnung ?? '',
    }));

    if (this.components && this.components.length > 1) {
      options.push({
        value: 'FIRMENWECHSEL_OEFFNEN',
        label: '#UTILITIES.CONTEXT.DETAIL_CONTEXT_SETTINGS',
        icon: 'fa-regular fa-user-gear',
      });
    }

    await this.patchContextService.patchContextOptionsDialog<string>({
      title: 'Vkforg auswählen',
      options,
      editContextDialogOptionValue: 'FIRMENWECHSEL_OEFFNEN',
      setOnSelect: (contextResult) => {
        return {
          firmaid: +contextResult,
        };
      },
    });
  }
}
